import * as types from '../actions/ActionTypes';
import { InstructionInitial } from '../store/InitialStore';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { EditorState } from 'draft-js';

export default function InstructionReducer(state = InstructionInitial, action) {
  const { type, payload, value, index, id } = action;

  const { formValues = [] } = state;
  switch (type) {
    case types.INSTRUCTION_ADD_NEW_FIELD:
      return {
        ...state,
        formValues: [
          ...formValues,
          {
            uniqueId: Date.now().toString(),
            selectedValue: '',
            // selectedData: EditorState.createEmpty(),
          },
        ],
      };

    case types.INSTRUCTION_DELETE:
      const Del = formValues.filter((Del) => Del.uniqueId != payload);
      return { ...state, formValues: Del };

    case types.INSTRUCTION_VALUE_CHANGES:
      // console.log('payload', payload, value);
      formValues.find((f) => f.uniqueId == id)['selectedValue'] = value;
      // const data = formValues.map((item) => {
      //   if (item.uniqueId == id) {
      //     return {
      //       ...item,
      //       selectedValue: value,
      //       selectedData: { ...action.data },
      //     };
      //   } else {
      //     return {
      //       ...item,
      //     };
      //   }
      // });
      // console.log('formValue', data);
      return {
        ...state,
        formValues: formValues,
      };

    case types.INSTRUCTION_DRAG_DROP:
      return { ...state, formValues: payload };

    case types.INSTRUCTION_RESET_STATE:
      return {
        ...state,
        formValues: [],
      };

    case types.INSTRUCTION_SAVE_VALUE:
      // console.log('payload', payload);

      return {
        ...state,
        formValues: payload,
      };

    default:
      return state;
  }
}
